import React from 'react';
import DropDown from '../dropdown';
import PropTypes from 'prop-types';
import { ReservationPolicy } from '../../../api/services/next';

const ReservationPoliciesDropDown = ({ searchByParent, ...props }) => {
  return (
    <DropDown
      search
      api={ReservationPolicy.GetReservationPolicies}
      textField='Name'
      valueField='Id'
      onChange={(value) => {
        if(searchByParent){
          props.onChange?.(value.PolicyId || value.Id);
        }
        props.onChange?.(value.Id);
      }}
      {...props}
    />
  );
};

ReservationPoliciesDropDown.propTypes = {
  HotelChainId: PropTypes.any,
  searchByParent: PropTypes.bool,
  onChange: PropTypes.func
};

export default ReservationPoliciesDropDown;
